export default __webpack_public_path__ + "static/media/Playlist-blue.7853d64a.svg";